import { getBaseApiUrl } from "api/getBaseApiUrl";
import axios, { AxiosRequestConfig } from "axios";

export async function generatePDFFromTemplate(template: string, token: AxiosRequestConfig, height: string) {
  const data = new FormData();
  data.append("Content", template);
  data.append("FileName", "Report.pdf");
  data.append("setPageWidth", "210mm");
  data.append("setPageHeight", height);
  data.append("setPageMargins", "0mm,0mm,0mm,0mm");

  const request = axios.create({
    baseURL: getBaseApiUrl(),
  });

  const response = await request.post("webApi/htmlToPdf/GetByContent", data, {
    responseType: "blob",
    headers: {
      token
    }
  });

  return response.data as Blob;
}
